import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";

const CustomFinanceCitySelect = ({ cityList, name, handleCityChange, value, apiLoading }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // Store filtered data
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const pageSize = 50;

    useEffect(() => {
        if (cityList?.length) {
            setData(cityList.slice(0, pageSize));
            setFilteredData(cityList);
        }
        else {
            setData([]);
            setFilteredData([]);
        }
    }, [cityList]);

    const handleScroll = (event) => {
        const { target } = event;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 20) {
            loadMore();
        }
    };

    const loadMore = () => {
        if (loading || page * pageSize >= filteredData.length) return;

        setLoading(true);
        setTimeout(() => {
            setData((prev) => [
                ...prev,
                ...filteredData.slice(page * pageSize, (page + 1) * pageSize),
            ]);
            setPage((prev) => prev + 1);
            setLoading(false);
        }, 500);
    };

    const handleSearch = (value) => {
        if (!value) {
            setFilteredData(cityList);
            setData(cityList.slice(0, pageSize));
            setPage(1);
            return;
        }

        const filtered = cityList.filter((city) =>
            city.toLowerCase().includes(value.toLowerCase())
        );

        setFilteredData(filtered);
        setData(filtered.slice(0, pageSize));
        setPage(1);
    };

    return (
        <Select
            name={name}
            disabled={apiLoading}
            className="finace-ant-select-form w-100"
            placeholder="Select City"
            showSearch
            onChange={(e) => handleCityChange(name, e)}
            value={value || undefined}
            onSearch={handleSearch}
            filterOption={false}
            onPopupScroll={handleScroll}
            options={data.map((city) => ({ label: city, value: city }))}
            dropdownRender={(menu) => (
                <>
                    {menu}
                    {loading && <Spin style={{ display: "block", textAlign: "center", padding: "10px" }} />}
                </>
            )}
        />
    );
};

export default CustomFinanceCitySelect;